import clsx from 'clsx';
import { Link } from 'components/UI/Link/styled';
import React from 'react';
import { LinkProps as RouterLinkProps } from 'react-router-dom';

import s from './Sidebar.module.less';

export const SidebarInner: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => (
  <div {...rest} className={clsx(s.sidebarInner, className)} />
);

export const SidebarMenu: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => (
  <div {...rest} className={clsx(s.sidebarMenu, className)} />
);

export const SidebarMenuItemAnchor: React.FC<React.AnchorHTMLAttributes<HTMLAnchorElement>> = ({
  className,
  ...rest
}) => (
  // eslint-disable-next-line jsx-a11y/anchor-has-content
  <a {...rest} className={clsx(s.sidebarMenuItemAnchor, className)} />
);

type SidebarMenuItemLinkProps = RouterLinkProps & { selected?: boolean };

export const SidebarMenuItemLink: React.FC<SidebarMenuItemLinkProps> = ({ selected, className, ...rest }) => (
  <Link {...rest} className={clsx(s.sidebarMenuItem, { [s.selected]: selected }, className)} />
);

type SidebarMenuItemProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & { selected?: boolean };

export const SidebarMenuItem: React.FC<SidebarMenuItemProps> = ({ selected, className, ...rest }) => (
  // eslint-disable-next-line jsx-a11y/anchor-has-content
  <a {...rest} className={clsx(s.sidebarMenuItem, { [s.selected]: selected }, className)} />
);

export const SidebarTitle: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => (
  <div {...rest} className={clsx(s.sidebarTitle, className)} />
);
